import { create } from "zustand"
import { persist } from "zustand/middleware"

export enum MembershipType {
  Free = 'Free Member',
  Premium = 'Premium Member',
  VIP = 'VIP Member',
}


export interface User {
  id?: string
  firstName?: string
  lastName?: string
  email?: string
  phone?: string
  avatar?: string
  memberSince?: string
  referralCode?: string
  referralRewards?: {
    NGN?: number
    [key: string]: number | undefined // allow other currencies if needed
  }
  referrals?: any[],
  referredBy?:string
  membership: MembershipType;
  isVerified:boolean
  address:string
  dob:string
}

interface AuthState {
  user: User | null
  profile: Record<string, any> | null
  isAuthenticated: boolean
  login: (user: User) => void
  logout: () => void
  updateUser: (updates: Partial<User>) => void
  setProfile: (profile: Record<string, any>) => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      profile: null,
      isAuthenticated: false,
      login: (user) => set({ user, isAuthenticated: true }),
      logout: () => set({ user: null, profile: null, isAuthenticated: false }),
      updateUser: (updates) => {
        const currentUser = get().user
        if (currentUser) {
          set({ user: { ...currentUser, ...updates } })
        }
      },
      setProfile: (profile) => set({ profile }),
    }),
    {
      name: "luxury-jeff-auth",
    },
  ),
)
